// Фото из объектного хранилища иногда «висят» серым десятки секунд: отдельный запрос в общем HTTP/2-соединении
// к S3 залипает, хотя то же фото в новой вкладке открывается сразу (Алексей 29.10 #3285, отчёт Остоженки
// за 19.10: из ~200 фото 105 стояли >30 с). Сторож на всё приложение: картинка не пришла за STALL_MS (10 с) —
// перезапрашиваем её тем же адресом с другим #фрагментом. Фрагмент на сервер не уходит (подпись
// presigned-URL цела), но для браузера это новый запрос. Компоненты не трогаем — работает для любого <img>.

const STALL_MS = 10000;
const TICK_MS = 2000;
const MAX_RETRIES = 3;

const seen = new WeakMap<HTMLImageElement, { src: string; since: number; tries: number }>();

function baseOf(src: string): string {
  const i = src.indexOf('#');
  return i < 0 ? src : src.slice(0, i);
}

function tick() {
  const now = Date.now();
  for (const img of Array.from(document.images)) {
    const src = img.currentSrc || img.src;
    if (!src || src.startsWith('data:') || src.startsWith('blob:')) continue;
    if (img.complete) { seen.delete(img); continue; }
    if (img.loading === 'lazy' && !isNearViewport(img)) continue;
    const base = baseOf(src);
    const st = seen.get(img);
    if (!st || st.src !== base) { seen.set(img, { src: base, since: now, tries: 0 }); continue; }
    if (now - st.since < STALL_MS || st.tries >= MAX_RETRIES) continue;
    st.tries += 1;
    st.since = now;
    img.src = `${base}#r${st.tries}`;
  }
}

function isNearViewport(img: HTMLImageElement): boolean {
  const r = img.getBoundingClientRect();
  return r.bottom > -500 && r.top < window.innerHeight + 500;
}

export function installImageWatchdog() {
  if (typeof window === 'undefined') return;
  window.setInterval(tick, TICK_MS);
}
